import React from "react";
import { Img, staticFile } from "remotion";

export interface MythicRankBadgeProps {
  tier?: "mythic" | "glory";
  stars?: number;
  label?: string;
  translateZ?: number;
  scale?: number;
  translateY?: number;
}

export const MythicRankBadge: React.FC<MythicRankBadgeProps> = ({
  tier = "glory",
  stars = 84,
  label = "AKUN RANK TINGGI",
  translateZ = 95,
  scale = 1,
  translateY = 0,
}) => {
  const assetName = tier === "glory" 
    ? "assets_library/ranks/rank_mythical_glory_official.png" 
    : "assets_library/ranks/rank_mythic_official.png";
  
  const rankTitle = tier === "glory" ? `Mythical Glory ${stars} Bintang` : `Mythic ${stars} Bintang`;

  return (
    <div
      style={{
        position: "relative",
        transformStyle: "preserve-3d",
        transform: `translateZ(${translateZ}px) translateY(${translateY}px) scale(${scale})`,
        backgroundColor: "#FFFFFF",
        borderRadius: 24,
        border: "2px solid #E2E8F0",
        padding: "16px 22px",
        boxShadow: "0 18px 40px rgba(93, 63, 211, 0.16), 0 8px 15px rgba(0,0,0,0.06)",
        display: "flex",
        alignItems: "center",
        gap: 16,
        zIndex: 35,
      }}
    >
      {/* Official 3D Mythic Dragon Crest */}
      <div style={{ width: 62, height: 62, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Img
          src={staticFile(assetName)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            filter: "drop-shadow(0 6px 14px rgba(93, 63, 211, 0.4))",
          }}
        />
      </div>

      <div>
        <div style={{ fontFamily: "'Chakra Petch', sans-serif", fontSize: 12, fontWeight: 700, color: "#64748B", letterSpacing: "0.08em" }}>
          {label}
        </div>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 24, color: "#0F172A", letterSpacing: "0.02em", marginTop: 2 }}>
          {rankTitle}
        </div>
        <div style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 13, fontWeight: 800, color: "#10B981" }}>
          ✓ Wajib Top-Up Resmi & Legal
        </div>
      </div>
    </div>
  );
};
